export default {
  createExcel(header, content) {
    return fetch(`${process.env.VUE_APP_API_URL}/excel/write-excel`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        header: header,
        content: content
      })
    })
      .then(res => {
        if (res.ok) {
          return res.blob()
        } else {
          throw Error('could not get remote XLSX')
        }
      })
      .catch(err => {
        this.loading = false
        this.$store.dispatch(
          'showErrorSnackbar',
          err.message || 'Something went wrong'
        )
      })
  },
  readExcel(excelFile) {
    var fd = new FormData()
    fd.append('file', excelFile /*, optional filename */)

    return fetch(`${process.env.VUE_APP_API_URL}/excel/read-excel`, {
      method: 'POST',
      body: fd
    }).then(res => {
      if (res.ok) {
        return res.json()
      } else {
        throw Error('could not get remote XLSX')
      }
    })
  }
}
